// =============================================================================
// src/features/crisis/crisis-narrative-data.ts
// Dados fictícios do painel "Narrativa × Contra-narrativa · leitura de enquadramento".
//
// Decisão de produto 2026-06-01 (time de análise). Descrição POR TEMA (compliance):
// zero nome de autor real; o cartão histórico cita FONTES de leitura, não alega
// treino de modelo. Padrão de dados espelha reputation-data.ts (interfaces + const).
//
// SRP: só dados. Sem DOM, sem timers.
// =============================================================================

/** Modo de resposta sugerido conforme a leitura do público/enquadramento. */
export type NarrativeMode = 'ancorar-fato' | 'trocar-eixo' | 'nao-alimentar';

/** Linha "Se … / Então …" de um modo de resposta. */
export interface NarrativeModeRow {
  readonly mode: NarrativeMode;
  readonly label: string;
  readonly when: string;
  readonly then: string;
  readonly icon: string;
}

/** Os 3 modos (a tese central do analista-midia + estrategista-crise). */
export const CRISIS_NARRATIVE_MODES: readonly NarrativeModeRow[] = [
  {
    mode: 'ancorar-fato', label: 'Ancorar no fato', icon: 'ti-file-check',
    when: 'Se o público é aberto (busca informação)',
    then: 'Publique o edital, o valor real e o cronograma — o fato dissolve o recorte.',
  },
  {
    mode: 'trocar-eixo', label: 'Trocar o eixo', icon: 'ti-arrows-shuffle',
    when: 'Se o público é fechado (câmara de eco identitária)',
    then: 'O fato não dissolve; reposicione o debate para o terreno onde você ganha.',
  },
  {
    mode: 'nao-alimentar', label: 'Não alimentar', icon: 'ti-eye-off',
    when: 'Se responder amplifica mais do que silenciar',
    then: 'Monitore e deixe o ciclo passar — responder daria palco ao ataque.',
  },
];

/** Modo recomendado p/ a crise ILUSTRATIVA do gabinete (público aberto → ancorar). */
export const CRISIS_NARRATIVE_CURRENT: NarrativeMode = 'ancorar-fato';

/** Tripé do enquadramento da resposta: boato vs fato vs meu enquadramento. */
export interface NarrativeFrameRow {
  readonly kind: 'boato' | 'fato' | 'meu';
  readonly label: string;
  readonly text: string;
}

/** O cartão fato×boato + "meu enquadramento" (pedido do agente-politico). */
export const CRISIS_NARRATIVE_FRAME: readonly NarrativeFrameRow[] = [
  { kind: 'boato', label: 'Boato / recorte', text: '"Obra superfaturada" — recorte de 18s da fala do senador, sem o contexto do edital.' },
  { kind: 'fato', label: 'Fato (edital público)', text: 'Valor e cronograma reais constam do edital público da reforma — verificáveis.' },
  { kind: 'meu', label: 'Meu enquadramento (sugestão editável)', text: 'Transparência total: aqui estão o edital, o valor e o cronograma da obra.' },
];

/** Cartão didático de exemplo histórico (referência rotulada, separada do mock). */
export interface NarrativeHistoricalCard {
  readonly title: string;
  readonly eixoDe: string;
  readonly eixoPara: string;
  readonly modo: string;
  readonly fonte: string;
}

/** Tarifaço 2025: virada de eixo verificada (por TEMA, sem alegar modelo treinado). */
export const CRISIS_NARRATIVE_HISTORICAL: NarrativeHistoricalCard = {
  title: 'Tarifaço 2025 — virada de enquadramento',
  eixoDe: 'pressão externa / julgamento no STF',
  eixoPara: 'soberania nacional / quem defende o emprego',
  modo: 'Trocar o eixo',
  fonte: 'Genial/Quaest ago/2025; Migalhas jul/2025',
};
